let gMlConfig;

export function setMlConfig(config){
  gMlConfig = config;
  return gMlConfig;
}

export function getMlConfig(){
  return gMlConfig;
}
